import { useMemo } from "react";
import "./skills-container1.css";

const SkillsContainer1 = ({
  technologyIcon,
  languageProficiency,
  propLeft,
  propTop,
  propLeft1,
  propWidth,
}) => {
  const skills1Style = useMemo(() => {
    return {
      left: propLeft,
      top: propTop,
    };
  }, [propLeft, propTop]);

  const divStyle = useMemo(() => {
    return {
      left: propLeft1,
    };
  }, [propLeft1]);

  const rectangleDivStyle = useMemo(() => {
    return {
      width: propWidth,
    };
  }, [propWidth]);

  return (
    <div className="skills-1" style={skills1Style}>
      <div className="skills-1-child" />
      <div className="figma">{technologyIcon}</div>
      <div className="div" style={divStyle}>
        {languageProficiency}
      </div>
      <div className="skills-1-item" />
      <div className="skills-1-inner" style={rectangleDivStyle} />
    </div>
  );
};

export default SkillsContainer1;
